<template>
  <div id="app">
    <h1 class="categoryTitle">Proveri simptome</h1>

    <ul class="check-symptoms-breadcrumbs">
      <li v-bind:class="{ active: activeStep === 1 }">Info</li>
      <li v-bind:class="{ active: activeStep === 2 }">Simptomi</li>
      <li v-bind:class="{ active: activeStep === 3 }">Pitanja</li>
      <li v-bind:class="{ active: activeStep === 4 }">Detalji</li>
      <li v-bind:class="{ active: activeStep === 5 }">Lečenje</li>
    </ul>

    <div 
      class="symptoms-test" 
      v-bind:class="{ 'check-symptoms-info': activeStep === 1, 'test-results': activeStep === 4 || activeStep === 5 }">

      <div class="step-container">
        <first-step-info 
          v-show="activeStep === 1"
          :age="age"
          :gender="gender"
          @ageChange="onAgeChange"
          @genderChange="onGenderChange">
        </first-step-info>
        <second-step-symptoms 
          v-show="activeStep === 2"
          :activeStep="activeStep"
          :age="age"
          :gender="gender"
          :symptoms="symptoms"
          :conditions="conditions"
          :drugs="drugs"
          @symptomAdded="onAddSymptom"
          @symptomRemoved="onRemoveSymptom"
          @editData="onEditData">
        </second-step-symptoms>
        <third-step-questions 
          v-show="activeStep === 3"
          :activeStep="activeStep"
          :age="age"
          :gender="gender"
          :symptoms="symptoms"
          :conditions="conditions"
          :drugs="drugs"
          @editData="onEditData"
          @drugAdded="onAddDrug"
          @drugRemoved="onRemoveDrug"
          @conditionAdded="onAddCondition"
          @conditionRemoved="onRemoveCondition"
          @sectionSkipped="onNext">
        </third-step-questions>
        <fourth-step-details 
          v-show="activeStep === 4 || activeStep === 5"
          @tabChanged="onEditData"
          :activeStep="activeStep"
          :testResults="testResults"
          :firstItem="testResults.length > 0 ? testResults[0] : null">
        </fourth-step-details>
      </div>

      <div 
        class="buttons-container test-results-buttons-container" 
        v-bind:class="{ 'first-step': activeStep === 1 }">
        <button  
          class="back-btn" 
          v-bind:class="{ hide: activeStep === 1 }"
          v-on:click="onBack">
          Nazad
        </button>
        <button  
          class="continue-btn greenButton" 
          v-bind:class="{ hide: activeStep === 5, disabled: disableNextButton }"
          :disabled="disableNextButton"
          v-on:click="onNext">
          Nastavite
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import FirstStepInfo from './components/FirstStepInfo';
import SecondStepSymptoms from './components/SecondStepSymptoms';
import ThirdStepQuestions from './components/ThirdStepQuestions';
import FourthStepDetails from './components/FourthStepDetails';
import fetchService from './services/fetchService.js';

export default {
  name: 'app',
  components: {
    FirstStepInfo,
    SecondStepSymptoms,
    ThirdStepQuestions,
    FourthStepDetails,
  },

  data(){
    return {
      activeStep: 1,
      age: '',
      gender: '',
      symptoms: [],
      drugs: [],
      conditions: [],
      testResults: [],
    }
  },

  methods: {
    async onNext () {
       if (this.activeStep === 1) {
        mixpanel.track("Start step 2 - check-symptoms test");
        ga('set', 'page', '/proveri-simptome/step-2');
        ga('send', 'pageview');
        this.activeStep += 1;
      } else if (this.activeStep === 2) {
        mixpanel.track("Start step 3 - check-symptoms test");
        ga('set', 'page', '/proveri-simptome/step-3');
        ga('send', 'pageview');
        this.activeStep += 1;
      } else if (this.activeStep === 3) {
        let results = await fetchService.fetchTestResults(this.symptoms, this.gender);
        this.testResults = results;
        mixpanel.track("Start step 4 - check-symptoms test");
        ga('set', 'page', '/proveri-simptome/step-4');
        ga('send', 'pageview');
        this.activeStep +=1;
      } else if (this.activeStep === 4) {
        mixpanel.track("Start step 5 - check-symptoms test");
        ga('set', 'page', '/proveri-simptome/step-5');
        ga('send', 'pageview');
        console.log('step-5');
        this.activeStep += 1;
      }
    },

    onBack () {
      if (this.activeStep === 5) {
        mixpanel.track("Start step 4 - check-symptoms test");
        ga('set', 'page', '/proveri-simptome/step-4');
        ga('send', 'pageview');
        this.activeStep -= 1;
      } else if (this.activeStep === 4) {
        mixpanel.track("Start step 3 - check-symptoms test");
        ga('set', 'page', '/proveri-simptome/step-3');
        ga('send', 'pageview');
        this.activeStep -= 1;
      } else if (this.activeStep === 3) {
        mixpanel.track("Start step 2 - check-symptoms test");
        ga('set', 'page', '/proveri-simptome/step-2');
        ga('send', 'pageview');
        this.activeStep -= 1;
      } else if (this.activeStep === 2) {
        mixpanel.track("Start check-symptoms test");
        ga('set', 'page', '/proveri-simptome');
        ga('send', 'pageview');
        this.activeStep -= 1;
      } else {
        this.activeStep -= 1;
      }
    },
    onAgeChange(age) {
      this.age = age;
    },
    onGenderChange(gender) {
      this.gender = gender;
    },
    onAddSymptom(symptom) {
      let symptomExist = this.symptoms.some(item => {
        return item.id === symptom.id;
      });
      if (!symptomExist) {
        this.symptoms.push(symptom);
      }
    },
    onRemoveSymptom(symptom) {
      this.symptoms = this.symptoms.filter(function(item) {
        return item.id !== symptom.id;
      })
    },
    onEditData(step) {
      this.activeStep = step;
    },
    onAddDrug(drug) {
      let drugExist = this.drugs.some(item => {
        return item.id === drug.id;
      });
      if (!drugExist) {
        this.drugs.push(drug);
      }
    },
    onRemoveDrug(drug) {
      this.drugs = this.drugs.filter(function(item) {
        return item.id !== drug.id;
      });
    },
    onAddCondition(condition) {
      let conditionExist = this.conditions.some(item => {
        return item.id === condition.id;
      });
      if (!conditionExist) {
        this.conditions.push(condition);
      }
    },
    onRemoveCondition(condition) {
      this.conditions = this.conditions.filter(function(item) {
        return item.id !== condition.id;
      });
    },
  },

  computed: {
    disableNextButton: function () {
      let emptyBasicInfo = this.activeStep === 1 && (this.age.length === 0 || this.gender.length === 0);
      let notSelectedSymptoms = this.activeStep === 2 && this.symptoms.length === 0;
      return emptyBasicInfo || notSelectedSymptoms;
    },
  }
}
</script>

<style>
</style>
